import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { possibilities, apps, dbs } from '../constants/devops';
import styles from '../styles/devops.module.scss';
import Link from 'next/link';
import Image from 'next/image';

export default function DevOps() {
  const router = useRouter();
  const { t } = useTranslation('devops');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection
        title={t('mainTitle')}
        description={t('devopsDescription')}
        documentationLink='https://help.icdc.io/devops/'
        lang={router.locale}
      />
      <div className={styles.description}>
        <div>
          <h2>{t('devops.title')}</h2>
          <p>{t('devops.description')}</p>
          <h2>{t('pipeline.title')}</h2>
          <p>{t('pipeline.description')}</p>
        </div>
        <Image src='/services/devops_service/devops.webp' alt="Devops" width={841} height={419} unoptimized loading='lazy' />
      </div>
      <div className={styles.ci}>
        <div className={styles.ci_inner}>
          <h2>{t('pipeline_phase.title')}</h2>
          <ul>
            {
              new Array(7).fill('').map((_, key) => <li key={key}>
                {t(`pipeline_phase.phase${key + 1}`)}
              </li>)
            }
          </ul>
        </div>
      </div>

      <section className={'flex ' + styles.stages}>
        <h2>{t('pipeline_stages.description')}</h2>
        <div className={'flex ' + styles.pipelines}>
          {
            new Array(9).fill('').map((_, key) => <div key={key} className={'flex ' + styles.chevron}>
              <p dangerouslySetInnerHTML={{__html: t(`pipeline_stages.stage${key + 1}`, { interpolation: { escapeValue: false }})}} />
            </div>)
          }
        </div>
      </section>

      <div className={styles.possibility}>
        <h2>{t('practice.title')}</h2>
        <p>{t('practice.description')}</p>
        <ul>
          {
            new Array(6).fill('').map((_, key) => <li key={key}>
              {t(`practice.possibility${key + 1}`)}
            </li>)
          }
        </ul>
      </div>

      <section className={styles.admins}>
        <div className={styles.possibilities}>
          {
            possibilities.map((possibility, key) => <div key={key} className='flex col'>
              <Image src={possibility.img} layout='fixed' alt="" loading='lazy' />
              <h3>{t(possibility.title)}</h3>
              <p>{t(possibility.description)}</p>
            </div>)
          }
        </div>
      </section>

      <div className={'flex col ' + styles.apps}>
        <h2>{t('applications.name')}</h2>
        <p>{t('applications.description')}</p>
        <h3>{t('applications.title_frameworks')}</h3>
        <div className={'flex ' + styles.langs}>
          {
            apps.map((app, key) => <div key={key} className={'flex ' + styles.app}>
              <Image src={app.img} alt='App' loading='lazy' unoptimized width={app.width} height={app.height} />
            </div>)
          }
        </div>
        <h3>{t('applications.title_bd')}</h3>
        <div className={'flex ' + styles.dbs}>
          {
            dbs.map((app, key) => <div key={key} className={'flex ' + styles.app}>
              <Image src={app.img} alt='App' loading='lazy' unoptimized width={app.width} height={app.height} />
            </div>)
          }
        </div>
      </div>

      <div className={styles.tools}>
        <h2>{t('tools.name')}</h2>
        <p>{t('tools.description')}</p>
        <div className={styles.advantages}>
          {
            new Array(4).fill('').map((_, key) => <div key={key} className='flex'>
              <h3>{t(`tools.advantage${key + 1}.title`)}</h3>
              <p>{t(`tools.advantage${key + 1}.description`)}</p>
              {key < 2 && <a href={t(`tools.advantage${key + 1}.href`)}>{t(`tools.advantage${key + 1}.link`)}
                <span className='sr-only'>{t(`tools.advantage${key + 1}.link_description`)}</span>
              </a>}
            </div>)
          }
        </div>
      </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['devops', 'common']),
  }
});
